export const users =  [
        {
            name: "AtomOtter",
            nickName: "Krisz",
            imgUrl: "https://avatars.fastly.steamstatic.com/7742098b00f24ea6f0b2d1533aeda6b7dbe83cd3_full.jpg",
            steamID: "76561197961713091"
        },
        {
            name: "SeeOtter",
            nickName: "Marcus",
            imgUrl: "https://avatars.akamai.steamstatic.com/0812eda6fb750e524e7ed90111a2a838ca7d8af2_full.jpg",
            steamID: "76561198098537805"
        },
        {
            name: "Otterkringer",
            nickName: "Roland",
            imgUrl: "https://avatars.akamai.steamstatic.com/a4ab6a447898f21c1648cfc6f9e0bf02a3b048be_full.jpg",
            steamID: "76561197963207381"
        },
        {
            name: "Ottfried Otter",
            nickName: "Daniel K.",
            imgUrl: "https://avatars.akamai.steamstatic.com/835b43a79956e6586e0ca06de2c5b0f0ccd6fcac_full.jpg",
            steamID: "76561198065449271"
        },
        {
            name: "HairyOtter",
            nickName: "Maxi",
            imgUrl: "https://avatars.akamai.steamstatic.com/178e9ce5f37c8fde2f3935d44a9eaf3e0c393ac6_full.jpg",
            steamID: "76561198050802830"
        },
        {
            name: "Otterburger",
            nickName: "Simon",
            imgUrl: "https://avatars.fastly.steamstatic.com/0ecf73bc09d7ded71d44394bd91613e6eb9acc06_full.jpg",
            steamID: "76561198069988123"
        },
        {
            name: "Otterdamm",
            nickName: "Ossi",
            imgUrl: "https://avatars.fastly.steamstatic.com/f602a9a5809f2a977c7b534c8c5e554de2538172_full.jpg",
            steamID: "76561198013392826"
        },
        {
            name: "Otterschmidt",
            nickName: "Nikki",
            imgUrl: "https://avatars.fastly.steamstatic.com/5b6a8a3f7911df08c8e397f8dcd85776352ad372_full.jpg",
            steamID: "76561197978083305"
        }
    ]

export default{
    users,
}












// alter Code in der Profile.Js bei Const...
    // const accounts = [
    //     {
    //         name: "AtomOtter",
    //         nickName: "Krisz",
    //         imgUrl: "https://avatars.akamai.steamstatic.com/7742098b00f24ea6f0b2d1533aeda6b7dbe83cd3_medium.jpg"
    //     },
    //     {
    //         name: "SeeOtter",
    //         nickName: "Marcus",
    //         imgUrl: "https://avatars.akamai.steamstatic.com/0812eda6fb750e524e7ed90111a2a838ca7d8af2_full.jpg"
    //     },
    //     {
    //         name: "Otterkringer",
    //         nickName: "Roland",
    //         imgUrl: "https://avatars.akamai.steamstatic.com/a4ab6a447898f21c1648cfc6f9e0bf02a3b048be_full.jpg"
    //     },
    //     {
    //         name: "Ottfried Otter",
    //         nickName: "Daniel K.",
    //         imgUrl: "https://avatars.akamai.steamstatic.com/835b43a79956e6586e0ca06de2c5b0f0ccd6fcac_full.jpg"
    //     }
    // ]